export default [
    'step-forward',
    'step-backward',
    'forward',
    'backward',
    'caret-right',
    'caret-left',
    'caret-down',
    'caret-up',
    'right-circle',
    'circle-right',
    'caret-circle-right',
    'left-circle',
    'circle-left',
    'caret-circle-left',
    'up-circle',
    'circle-up',
    'caret-circle-up',
    'down-circle',
    'circle-down',
    'caret-circle-down',
    'right-circle-o',
    'circle-o-right',
    'caret-circle-o-right',
    'left-circle-o',
    'circle-o-left',
    'caret-circle-o-left',
    'up-circle-o',
    'circle-o-up',
    'caret-circle-o-up',
    'down-circle-o',
    'caret-circle-o-down',
    'verticle-left',
    'verticle-right',
    'rollback',
    'retweet',
    'shrink',
    'arrows-alt',
    'arrow-salt',
    'reload',
    'double-right',
    'double-left',
    'arrow-down',
    'arrow-up',
    'arrow-right',
    'arrow-left',
    'down',
    'up',
    'right',
    'left',
    'minus-square-o',
    'minus-circle',
    'minus-circle-o',
    'minus',
    'plus-circle-o',
    'plus-circle',
    'plus',
    'info-circle',
    'info-circle-o',
    'info',
    'exclamation',
    'exclamation-circle',
    'exclamation-circle-o',
    'close-circle',
    'cross-circle',
    'close-circle-o',
    'cross-circle-o',
    'check-circle',
    'check-circle-o',
    'check',
    'close',
    'cross',
    'customer-service',
    'customerservice',
    'credit-card',
    'code-o',
    'book',
    'bar-chart',
    'bars',
    'question',
    'question-circle',
    'question-circle-o',
    'pause',
    'pause-circle',
    'pause-circle-o',
    'clock-circle',
    'clock-circle-o',
    'swap',
    'swap-left',
    'swap-right',
    'plus-square-o',
    'frown',
    'frown-circle',
    'ellipsis',
    'copy',
    'menu-fold',
    'mail',
    'logout',
    'link',
    'area-chart',
    'line-chart',
    'home',
    'laptop',
    'star',
    'star-o',
    'folder',
    'filter',
    'file',
    'exception',
    'meh',
    'meh-circle',
    'meh-o',
    'shopping-cart',
    'save',
    'user',
    'video-camera',
    'to-top',
    'team',
    'tablet',
    'solution',
    'search',
    'share-alt',
    'setting',
    'poweroff',
    'picture',
    'phone',
    'paper-clip',
    'notification',
    'mobile',
    'menu-unfold',
    'inbox',
    'lock',
    'qrcode',
    'play-circle',
    'play-circle-o',
    'tag',
    'tag-o',
    'tags',
    'tags-o',
    'cloud-o',
    'cloud',
    'cloud-upload',
    'cloud-download',
    'cloud-download-o',
    'cloud-upload-o',
    'environment',
    'environment-o',
    'eye',
    'eye-o',
    'camera',
    'camera-o',
    'windows',
    'apple',
    'apple-o',
    'android',
    'android-o',
    'aliwangwang',
    'aliwangwang-o',
    'export',
    'edit',
    'circle-down-o',
    'circle-down-',
    'appstore-o',
    'appstore',
    'scan',
    'file-text',
    'folder-open',
    'hdd',
    'ie',
    'file-jpg',
    'like',
    'like-o',
    'dislike',
    'dislike-o',
    'delete',
    'enter',
    'pushpin-o',
    'pushpin',
    'heart',
    'heart-o',
    'pay-circle',
    'pay-circle-o',
    'smile',
    'smile-circle',
    'smile-o',
    'frown-o',
    'calculator',
    'message',
    'chrome',
    'github',
    'file-unknown',
    'file-excel',
    'file-ppt',
    'file-word',
    'file-pdf',
    'desktop',
    'upload',
    'download',
    'pie-chart',
    'unlock',
    'calendar',
    'windows-o',
    'dot-chart',
    'code',
    'api',
    'plus-square',
    'minus-square',
    'close-square',
    'close-square-o',
    'check-square',
    'check-square-o',
    'fast-backward',
    'fast-forward',
    'up-square',
    'down-square',
    'left-square',
    'right-square',
    'right-square-o',
    'left-square-o',
    'down-square-o',
    'up-square-o',
    'loading',
    'loading-3-quarters',
    'bulb',
    'select',
    'addfile',
    'addfolder',
    'switcher',
    'rocket',
    'dingding',
    'dingding-o',
    'bell',
    'disconnect',
    'database',
    'compass',
    'barcode',
    'hourglass',
    'key',
    'flag',
    'layout',
    'login',
    'printer',
    'sound',
    'usb',
    'skin',
    'tool',
    'sync',
    'wifi',
    'car',
    'copyright',
    'schedule',
    'user-add',
    'user-delete',
    'usergroup-add',
    'usergroup-delete',
    'man',
    'woman',
    'shop',
    'gift',
    'idcard',
    'medicine-box',
    'red-envelope',
    'coffee',
    'trademark',
    'safety',
    'wallet',
    'bank',
    'trophy',
    'contacts',
    'global',
    'shake',
    'fork'
];
